/* eslint-disable formatjs/no-literal-string-in-jsx */

import React, { useRef } from 'react'
import classNames from 'classnames'

import { IconButton } from '@slite/components'
import {
  ArrowUpIcon,
  CalendarIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  LeftSidebarIcon,
  SearchAllIcon,
} from '@slite/icons'

import type { AiSearchScenario } from './content'
import { SearchConversation } from './SearchConversation'

// Mirrors @slite/screens SuperInput: textarea row, filter row with source +
// date IconButtons on the left and the secondary-purple send button on the
// right. Full chat width.
const Composer = () => (
  <div
    className={classNames(
      'flexbox-no-shrink flexbox flexbox-column',
      'background-shade-100 radius-xlarger border-small border-shade-45'
    )}
    style={{
      width: '100%',
      filter: 'drop-shadow(0px 0px 16px rgba(0, 0, 0, 0.04))',
    }}
  >
    <label className="flexbox padding-left-20 padding-right-12 padding-top-16">
      <textarea
        placeholder="Ask anything about your company knowledge"
        readOnly
        className="flexbox-grow placeholder-shade-30 shade-05"
        style={{
          border: 'none',
          outline: 'none',
          resize: 'none',
          background: 'transparent',
          fontFamily: 'inherit',
          fontSize: 15,
          lineHeight: '20px',
          minHeight: 20,
        }}
      />
    </label>
    <div
      className="flexbox flexbox-align-center flexbox-space-between padding-horizontal-12 padding-bottom-12"
      style={{ gap: 8 }}
    >
      <div className="flexbox flexbox-align-center" style={{ gap: 4 }}>
        <IconButton
          variant="quiet"
          size="small"
          icon={SearchAllIcon}
          aria-label="Sources"
        />
        <IconButton
          variant="quiet"
          size="small"
          icon={CalendarIcon}
          aria-label="Date"
        />
      </div>
      <div
        className={classNames(
          ' flexbox flexbox-centered ',
          'white background-saturn-orange'
        )}
        style={{
          height: 32,
          width: 32,
          borderRadius: 32 / 2,
        }}
      >
        <ArrowUpIcon />
      </div>
    </div>
  </div>
)

export const AppInterface = ({
  scenario,
  isActive,
  runKey,
}: {
  scenario: AiSearchScenario
  isActive: boolean
  runKey: number
}) => {
  const scrollRef = useRef<HTMLDivElement>(null)
  return (
    <div
      className="height-full"
      style={{
        background: 'rgba(249, 239, 228, 0.25)',
        borderRadius: '20px 20px 0 0',
        padding: '4px 4px 0 4px',
        pointerEvents: 'none',
      }}
    >
      <div
        className={classNames(
          'height-full ',
          'background-shade-100 border-top-small border-left-small border-right-small border-shade-45'
        )}
        style={{
          filter: 'drop-shadow(0px 0px 16px rgba(0, 0, 0, 0.04))',
          fontSize: 15,
          lineHeight: '1.5em',
          overflow: 'hidden',
          borderRadius: '16px 16px 0 0',
        }}
      >
        <div className="width-full height-full flexbox flexbox-column">
          <div
            className="flexbox-no-shrink"
            style={{
              width: '100%',
              height: 52,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              color: 'var(--shade-30)',
              padding: '0 20px',
              background: 'var(--shade-100)',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                fontWeight: 600,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <ChevronLeftIcon width={13} />
                <ChevronRightIcon width={13} />
              </div>
              Slite agent
            </div>
            <div>
              <LeftSidebarIcon
                width={16}
                style={{ transform: 'rotate(180deg)' }}
              />
            </div>
          </div>

          <div
            ref={scrollRef}
            className="position-relative scrollable flexbox-grow width-full"
            style={{ minHeight: 0 }}
          >
            <div
              className="flexbox flexbox-column flexbox-gap-20 text-align-left"
              style={{
                maxWidth: 620,
                width: '100%',
                margin: '0 auto',
                padding: '0 20px',
              }}
            >
              <SearchConversation
                scenario={scenario}
                isActive={isActive}
                runKey={runKey}
                scrollRef={scrollRef}
              />
            </div>
          </div>

          <div
            className="flexbox-no-shrink"
            style={{
              maxWidth: 620,
              width: '100%',
              margin: '0 auto',
              padding: '12px 20px',
              paddingTop: 32,
            }}
          >
            <Composer />
          </div>
        </div>
      </div>
    </div>
  )
}
